/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiTaxDeclarationAcknowledgeSalesforceDeletePost } from '../fn/tax-declaration/api-tax-declaration-acknowledge-salesforce-delete-post';
import { ApiTaxDeclarationAcknowledgeSalesforceDeletePost$Params } from '../fn/tax-declaration/api-tax-declaration-acknowledge-salesforce-delete-post';
import { apiTaxDeclarationAddressPatch } from '../fn/tax-declaration/api-tax-declaration-address-patch';
import { ApiTaxDeclarationAddressPatch$Params } from '../fn/tax-declaration/api-tax-declaration-address-patch';
import { apiTaxDeclarationFinalizePatch } from '../fn/tax-declaration/api-tax-declaration-finalize-patch';
import { ApiTaxDeclarationFinalizePatch$Params } from '../fn/tax-declaration/api-tax-declaration-finalize-patch';
import { apiTaxDeclarationIdApprovePost } from '../fn/tax-declaration/api-tax-declaration-id-approve-post';
import { ApiTaxDeclarationIdApprovePost$Params } from '../fn/tax-declaration/api-tax-declaration-id-approve-post';
import { apiTaxDeclarationIdDelete } from '../fn/tax-declaration/api-tax-declaration-id-delete';
import { ApiTaxDeclarationIdDelete$Params } from '../fn/tax-declaration/api-tax-declaration-id-delete';
import { apiTaxDeclarationIdRejectPost } from '../fn/tax-declaration/api-tax-declaration-id-reject-post';
import { ApiTaxDeclarationIdRejectPost$Params } from '../fn/tax-declaration/api-tax-declaration-id-reject-post';
import { apiTaxDeclarationInitializeDocumentPost$Json } from '../fn/tax-declaration/api-tax-declaration-initialize-document-post-json';
import { ApiTaxDeclarationInitializeDocumentPost$Json$Params } from '../fn/tax-declaration/api-tax-declaration-initialize-document-post-json';
import { apiTaxDeclarationInitializeDocumentPost$Plain } from '../fn/tax-declaration/api-tax-declaration-initialize-document-post-plain';
import { ApiTaxDeclarationInitializeDocumentPost$Plain$Params } from '../fn/tax-declaration/api-tax-declaration-initialize-document-post-plain';
import { apiTaxDeclarationInitializePost$Json } from '../fn/tax-declaration/api-tax-declaration-initialize-post-json';
import { ApiTaxDeclarationInitializePost$Json$Params } from '../fn/tax-declaration/api-tax-declaration-initialize-post-json';
import { apiTaxDeclarationInitializePost$Plain } from '../fn/tax-declaration/api-tax-declaration-initialize-post-plain';
import { ApiTaxDeclarationInitializePost$Plain$Params } from '../fn/tax-declaration/api-tax-declaration-initialize-post-plain';
import { apiTaxDeclarationInitializeSalesforceInsertPost$Json } from '../fn/tax-declaration/api-tax-declaration-initialize-salesforce-insert-post-json';
import { ApiTaxDeclarationInitializeSalesforceInsertPost$Json$Params } from '../fn/tax-declaration/api-tax-declaration-initialize-salesforce-insert-post-json';
import { apiTaxDeclarationInitializeSalesforceInsertPost$Plain } from '../fn/tax-declaration/api-tax-declaration-initialize-salesforce-insert-post-plain';
import { ApiTaxDeclarationInitializeSalesforceInsertPost$Plain$Params } from '../fn/tax-declaration/api-tax-declaration-initialize-salesforce-insert-post-plain';
import { apiTaxDeclarationInitializeSalesforceUpdatePost$Json } from '../fn/tax-declaration/api-tax-declaration-initialize-salesforce-update-post-json';
import { ApiTaxDeclarationInitializeSalesforceUpdatePost$Json$Params } from '../fn/tax-declaration/api-tax-declaration-initialize-salesforce-update-post-json';
import { apiTaxDeclarationInitializeSalesforceUpdatePost$Plain } from '../fn/tax-declaration/api-tax-declaration-initialize-salesforce-update-post-plain';
import { ApiTaxDeclarationInitializeSalesforceUpdatePost$Plain$Params } from '../fn/tax-declaration/api-tax-declaration-initialize-salesforce-update-post-plain';
import { apiTaxDeclarationLastGet$Json } from '../fn/tax-declaration/api-tax-declaration-last-get-json';
import { ApiTaxDeclarationLastGet$Json$Params } from '../fn/tax-declaration/api-tax-declaration-last-get-json';
import { apiTaxDeclarationLastGet$Plain } from '../fn/tax-declaration/api-tax-declaration-last-get-plain';
import { ApiTaxDeclarationLastGet$Plain$Params } from '../fn/tax-declaration/api-tax-declaration-last-get-plain';
import { apiTaxDeclarationStartPatch } from '../fn/tax-declaration/api-tax-declaration-start-patch';
import { ApiTaxDeclarationStartPatch$Params } from '../fn/tax-declaration/api-tax-declaration-start-patch';
import { apiTaxDeclarationYearGet$Json } from '../fn/tax-declaration/api-tax-declaration-year-get-json';
import { ApiTaxDeclarationYearGet$Json$Params } from '../fn/tax-declaration/api-tax-declaration-year-get-json';
import { apiTaxDeclarationYearGet$Plain } from '../fn/tax-declaration/api-tax-declaration-year-get-plain';
import { ApiTaxDeclarationYearGet$Plain$Params } from '../fn/tax-declaration/api-tax-declaration-year-get-plain';
import { TaxDeclarationResponse } from '../models/tax-declaration-response';

@Injectable({ providedIn: 'root' })
export class TaxDeclarationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTaxDeclarationYearGet()` */
  static readonly ApiTaxDeclarationYearGetPath = '/api/TaxDeclaration/{year}';

  /**
   * Get the user's tax declaration for a given tax year.
   *
   * Returns the full tax declaration (individuals, income, deductions, assets, properties, documents) belonging to the authenticated user for the specified tax year.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationYearGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationYearGet$Plain$Response(params: ApiTaxDeclarationYearGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxDeclarationResponse>> {
    const obs = apiTaxDeclarationYearGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the user's tax declaration for a given tax year.
   *
   * Returns the full tax declaration (individuals, income, deductions, assets, properties, documents) belonging to the authenticated user for the specified tax year.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationYearGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationYearGet$Plain(params: ApiTaxDeclarationYearGet$Plain$Params, context?: HttpContext): Observable<TaxDeclarationResponse> {
    const resp = this.apiTaxDeclarationYearGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TaxDeclarationResponse>): TaxDeclarationResponse => r.body)
    );
  }

  /**
   * Get the user's tax declaration for a given tax year.
   *
   * Returns the full tax declaration (individuals, income, deductions, assets, properties, documents) belonging to the authenticated user for the specified tax year.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationYearGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationYearGet$Json$Response(params: ApiTaxDeclarationYearGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxDeclarationResponse>> {
    const obs = apiTaxDeclarationYearGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the user's tax declaration for a given tax year.
   *
   * Returns the full tax declaration (individuals, income, deductions, assets, properties, documents) belonging to the authenticated user for the specified tax year.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationYearGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationYearGet$Json(params: ApiTaxDeclarationYearGet$Json$Params, context?: HttpContext): Observable<TaxDeclarationResponse> {
    const resp = this.apiTaxDeclarationYearGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TaxDeclarationResponse>): TaxDeclarationResponse => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationLastGet()` */
  static readonly ApiTaxDeclarationLastGetPath = '/api/TaxDeclaration/last';

  /**
   * Get the user's most recent tax declaration.
   *
   * Returns the most recent tax declaration belonging to the authenticated user, regardless of tax year. Handy as a starting point when the year is not yet known to the client.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationLastGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationLastGet$Plain$Response(params?: ApiTaxDeclarationLastGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxDeclarationResponse>> {
    const obs = apiTaxDeclarationLastGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the user's most recent tax declaration.
   *
   * Returns the most recent tax declaration belonging to the authenticated user, regardless of tax year. Handy as a starting point when the year is not yet known to the client.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationLastGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationLastGet$Plain(params?: ApiTaxDeclarationLastGet$Plain$Params, context?: HttpContext): Observable<TaxDeclarationResponse> {
    const resp = this.apiTaxDeclarationLastGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TaxDeclarationResponse>): TaxDeclarationResponse => r.body)
    );
  }

  /**
   * Get the user's most recent tax declaration.
   *
   * Returns the most recent tax declaration belonging to the authenticated user, regardless of tax year. Handy as a starting point when the year is not yet known to the client.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationLastGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationLastGet$Json$Response(params?: ApiTaxDeclarationLastGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxDeclarationResponse>> {
    const obs = apiTaxDeclarationLastGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the user's most recent tax declaration.
   *
   * Returns the most recent tax declaration belonging to the authenticated user, regardless of tax year. Handy as a starting point when the year is not yet known to the client.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationLastGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationLastGet$Json(params?: ApiTaxDeclarationLastGet$Json$Params, context?: HttpContext): Observable<TaxDeclarationResponse> {
    const resp = this.apiTaxDeclarationLastGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TaxDeclarationResponse>): TaxDeclarationResponse => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationInitializePost()` */
  static readonly ApiTaxDeclarationInitializePostPath = '/api/TaxDeclaration/initialize';

  /**
   * Initialize a new tax declaration manually.
   *
   * Creates an empty tax declaration for the authenticated user for the requested year. Returns the new declaration's id, which is then used to attach income/deductions/assets/etc.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationInitializePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializePost$Plain$Response(params: ApiTaxDeclarationInitializePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiTaxDeclarationInitializePost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Initialize a new tax declaration manually.
   *
   * Creates an empty tax declaration for the authenticated user for the requested year. Returns the new declaration's id, which is then used to attach income/deductions/assets/etc.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationInitializePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializePost$Plain(params: ApiTaxDeclarationInitializePost$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiTaxDeclarationInitializePost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * Initialize a new tax declaration manually.
   *
   * Creates an empty tax declaration for the authenticated user for the requested year. Returns the new declaration's id, which is then used to attach income/deductions/assets/etc.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationInitializePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializePost$Json$Response(params: ApiTaxDeclarationInitializePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiTaxDeclarationInitializePost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Initialize a new tax declaration manually.
   *
   * Creates an empty tax declaration for the authenticated user for the requested year. Returns the new declaration's id, which is then used to attach income/deductions/assets/etc.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationInitializePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializePost$Json(params: ApiTaxDeclarationInitializePost$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiTaxDeclarationInitializePost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationInitializeDocumentPost()` */
  static readonly ApiTaxDeclarationInitializeDocumentPostPath = '/api/TaxDeclaration/initialize-document';

  /**
   * Initialize a new tax declaration from a prior-year document.
   *
   * Creates a tax declaration for the supplied year by uploading the prior-year declaration document. The AI pipeline extracts and prefills the new declaration from that file. Multipart form: `year` plus the file.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationInitializeDocumentPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaxDeclarationInitializeDocumentPost$Plain$Response(params: ApiTaxDeclarationInitializeDocumentPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiTaxDeclarationInitializeDocumentPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Initialize a new tax declaration from a prior-year document.
   *
   * Creates a tax declaration for the supplied year by uploading the prior-year declaration document. The AI pipeline extracts and prefills the new declaration from that file. Multipart form: `year` plus the file.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationInitializeDocumentPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaxDeclarationInitializeDocumentPost$Plain(params: ApiTaxDeclarationInitializeDocumentPost$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiTaxDeclarationInitializeDocumentPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * Initialize a new tax declaration from a prior-year document.
   *
   * Creates a tax declaration for the supplied year by uploading the prior-year declaration document. The AI pipeline extracts and prefills the new declaration from that file. Multipart form: `year` plus the file.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationInitializeDocumentPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaxDeclarationInitializeDocumentPost$Json$Response(params: ApiTaxDeclarationInitializeDocumentPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiTaxDeclarationInitializeDocumentPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Initialize a new tax declaration from a prior-year document.
   *
   * Creates a tax declaration for the supplied year by uploading the prior-year declaration document. The AI pipeline extracts and prefills the new declaration from that file. Multipart form: `year` plus the file.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationInitializeDocumentPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiTaxDeclarationInitializeDocumentPost$Json(params: ApiTaxDeclarationInitializeDocumentPost$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiTaxDeclarationInitializeDocumentPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationInitializeSalesforceInsertPost()` */
  static readonly ApiTaxDeclarationInitializeSalesforceInsertPostPath = '/api/TaxDeclaration/initialize-salesforce-insert';

  /**
   * Initialize a tax declaration triggered by Salesforce (insert).
   *
   * Webhook-style endpoint. Called when Salesforce creates a tax-declaration record for a client (matched by smzhId). Creates the corresponding declaration in prisma.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationInitializeSalesforceInsertPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializeSalesforceInsertPost$Plain$Response(params: ApiTaxDeclarationInitializeSalesforceInsertPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiTaxDeclarationInitializeSalesforceInsertPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Initialize a tax declaration triggered by Salesforce (insert).
   *
   * Webhook-style endpoint. Called when Salesforce creates a tax-declaration record for a client (matched by smzhId). Creates the corresponding declaration in prisma.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationInitializeSalesforceInsertPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializeSalesforceInsertPost$Plain(params: ApiTaxDeclarationInitializeSalesforceInsertPost$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiTaxDeclarationInitializeSalesforceInsertPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * Initialize a tax declaration triggered by Salesforce (insert).
   *
   * Webhook-style endpoint. Called when Salesforce creates a tax-declaration record for a client (matched by smzhId). Creates the corresponding declaration in prisma.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationInitializeSalesforceInsertPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializeSalesforceInsertPost$Json$Response(params: ApiTaxDeclarationInitializeSalesforceInsertPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiTaxDeclarationInitializeSalesforceInsertPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Initialize a tax declaration triggered by Salesforce (insert).
   *
   * Webhook-style endpoint. Called when Salesforce creates a tax-declaration record for a client (matched by smzhId). Creates the corresponding declaration in prisma.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationInitializeSalesforceInsertPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializeSalesforceInsertPost$Json(params: ApiTaxDeclarationInitializeSalesforceInsertPost$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiTaxDeclarationInitializeSalesforceInsertPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationInitializeSalesforceUpdatePost()` */
  static readonly ApiTaxDeclarationInitializeSalesforceUpdatePostPath = '/api/TaxDeclaration/initialize-salesforce-update';

  /**
   * Apply a Salesforce-side update to a tax declaration.
   *
   * Webhook-style endpoint. Called when Salesforce updates a tax-declaration record; the corresponding declaration in prisma is updated accordingly.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationInitializeSalesforceUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializeSalesforceUpdatePost$Plain$Response(params: ApiTaxDeclarationInitializeSalesforceUpdatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiTaxDeclarationInitializeSalesforceUpdatePost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Apply a Salesforce-side update to a tax declaration.
   *
   * Webhook-style endpoint. Called when Salesforce updates a tax-declaration record; the corresponding declaration in prisma is updated accordingly.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationInitializeSalesforceUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializeSalesforceUpdatePost$Plain(params: ApiTaxDeclarationInitializeSalesforceUpdatePost$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiTaxDeclarationInitializeSalesforceUpdatePost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * Apply a Salesforce-side update to a tax declaration.
   *
   * Webhook-style endpoint. Called when Salesforce updates a tax-declaration record; the corresponding declaration in prisma is updated accordingly.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationInitializeSalesforceUpdatePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializeSalesforceUpdatePost$Json$Response(params: ApiTaxDeclarationInitializeSalesforceUpdatePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiTaxDeclarationInitializeSalesforceUpdatePost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Apply a Salesforce-side update to a tax declaration.
   *
   * Webhook-style endpoint. Called when Salesforce updates a tax-declaration record; the corresponding declaration in prisma is updated accordingly.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationInitializeSalesforceUpdatePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationInitializeSalesforceUpdatePost$Json(params: ApiTaxDeclarationInitializeSalesforceUpdatePost$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiTaxDeclarationInitializeSalesforceUpdatePost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationAcknowledgeSalesforceDeletePost()` */
  static readonly ApiTaxDeclarationAcknowledgeSalesforceDeletePostPath = '/api/TaxDeclaration/acknowledge-salesforce-delete';

  /**
   * Acknowledge deletion of a tax declaration from Salesforce.
   *
   * Webhook-style endpoint. Called when Salesforce deletes a tax-declaration record; the corresponding declaration in prisma is deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationAcknowledgeSalesforceDeletePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationAcknowledgeSalesforceDeletePost$Response(params: ApiTaxDeclarationAcknowledgeSalesforceDeletePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiTaxDeclarationAcknowledgeSalesforceDeletePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Acknowledge deletion of a tax declaration from Salesforce.
   *
   * Webhook-style endpoint. Called when Salesforce deletes a tax-declaration record; the corresponding declaration in prisma is deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationAcknowledgeSalesforceDeletePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationAcknowledgeSalesforceDeletePost(params: ApiTaxDeclarationAcknowledgeSalesforceDeletePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiTaxDeclarationAcknowledgeSalesforceDeletePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationStartPatch()` */
  static readonly ApiTaxDeclarationStartPatchPath = '/api/TaxDeclaration/start';

  /**
   * Move a tax declaration to the 'started' state.
   *
   * Transitions a tax declaration from its initial state to 'started', i.e. the client has begun filling it in. Used to drive UX state on landing pages and dashboards.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationStartPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationStartPatch$Response(params: ApiTaxDeclarationStartPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiTaxDeclarationStartPatch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Move a tax declaration to the 'started' state.
   *
   * Transitions a tax declaration from its initial state to 'started', i.e. the client has begun filling it in. Used to drive UX state on landing pages and dashboards.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationStartPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationStartPatch(params: ApiTaxDeclarationStartPatch$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiTaxDeclarationStartPatch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationAddressPatch()` */
  static readonly ApiTaxDeclarationAddressPatchPath = '/api/TaxDeclaration/address';

  /**
   * Set the address on a tax declaration.
   *
   * Patches the residential address recorded on the tax declaration (the address relevant for the tax year).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationAddressPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationAddressPatch$Response(params: ApiTaxDeclarationAddressPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiTaxDeclarationAddressPatch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Set the address on a tax declaration.
   *
   * Patches the residential address recorded on the tax declaration (the address relevant for the tax year).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationAddressPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationAddressPatch(params: ApiTaxDeclarationAddressPatch$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiTaxDeclarationAddressPatch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationFinalizePatch()` */
  static readonly ApiTaxDeclarationFinalizePatchPath = '/api/TaxDeclaration/finalize';

  /**
   * Finalize the tax declaration.
   *
   * Marks the tax declaration as complete from the client's side and hands it off to the advisor for review. After finalization, further client edits are blocked.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationFinalizePatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationFinalizePatch$Response(params: ApiTaxDeclarationFinalizePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiTaxDeclarationFinalizePatch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Finalize the tax declaration.
   *
   * Marks the tax declaration as complete from the client's side and hands it off to the advisor for review. After finalization, further client edits are blocked.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationFinalizePatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTaxDeclarationFinalizePatch(params: ApiTaxDeclarationFinalizePatch$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiTaxDeclarationFinalizePatch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationIdDelete()` */
  static readonly ApiTaxDeclarationIdDeletePath = '/api/TaxDeclaration/{id}';

  /**
   * Delete a tax declaration.
   *
   * Removes a tax declaration belonging to the authenticated user, including all child records (individuals, income, deductions, assets, properties). Documents referenced by those child records are not deleted by this call — delete each one separately via DELETE /api/Documents/{documentId}.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationIdDelete$Response(params: ApiTaxDeclarationIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiTaxDeclarationIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a tax declaration.
   *
   * Removes a tax declaration belonging to the authenticated user, including all child records (individuals, income, deductions, assets, properties). Documents referenced by those child records are not deleted by this call — delete each one separately via DELETE /api/Documents/{documentId}.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationIdDelete(params: ApiTaxDeclarationIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiTaxDeclarationIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationIdApprovePost()` */
  static readonly ApiTaxDeclarationIdApprovePostPath = '/api/TaxDeclaration/{id}/approve';

  /**
   * Client approves the advisor-reviewed declaration.
   *
   * Client action. After the advisor finishes reviewing the declaration and submits it back, the client confirms that all information is correct so the advisor knows they can proceed with filing.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationIdApprovePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationIdApprovePost$Response(params: ApiTaxDeclarationIdApprovePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiTaxDeclarationIdApprovePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Client approves the advisor-reviewed declaration.
   *
   * Client action. After the advisor finishes reviewing the declaration and submits it back, the client confirms that all information is correct so the advisor knows they can proceed with filing.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationIdApprovePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationIdApprovePost(params: ApiTaxDeclarationIdApprovePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiTaxDeclarationIdApprovePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTaxDeclarationIdRejectPost()` */
  static readonly ApiTaxDeclarationIdRejectPostPath = '/api/TaxDeclaration/{id}/reject';

  /**
   * Client rejects the advisor-reviewed declaration.
   *
   * Client action. After the advisor submits the reviewed declaration back to the client, the client rejects it and states what is wrong; the advisor reworks it and re-submits.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTaxDeclarationIdRejectPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationIdRejectPost$Response(params: ApiTaxDeclarationIdRejectPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiTaxDeclarationIdRejectPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Client rejects the advisor-reviewed declaration.
   *
   * Client action. After the advisor submits the reviewed declaration back to the client, the client rejects it and states what is wrong; the advisor reworks it and re-submits.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTaxDeclarationIdRejectPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTaxDeclarationIdRejectPost(params: ApiTaxDeclarationIdRejectPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiTaxDeclarationIdRejectPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
